export default function TermsPage() {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@700;800&family=Instrument+Sans:wght@400;500;600;700&family=Instrument+Serif:ital@0;1&display=swap');
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        body { background: #0c0a09; }
        @keyframes fadeUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }

        .tp-hero { animation: fadeUp 0.5s ease both; }
        .tp-section { animation: fadeUp 0.5s ease both; }
        .tp-section:nth-child(2) { animation-delay: 0.05s; }
        .tp-section:nth-child(3) { animation-delay: 0.1s; }
        .tp-section:nth-child(4) { animation-delay: 0.15s; }
        .tp-section:nth-child(5) { animation-delay: 0.2s; }
        .tp-section:nth-child(6) { animation-delay: 0.25s; }
        .tp-section:nth-child(7) { animation-delay: 0.3s; }
        .tp-section:nth-child(8) { animation-delay: 0.35s; }

        @media (max-width: 640px) {
          .tp-nav-wordmark { font-size: 17px !important; }
          .tp-hero-title { font-size: 28px !important; }
          .tp-hero-meta { flex-direction: column !important; gap: 6px !important; }
          .tp-content { padding: 24px 18px 60px !important; }
          .tp-section-title { font-size: 15px !important; }
          .tp-body { font-size: 14px !important; }
          .tp-highlight { padding: 14px 16px !important; }
          .tp-contact-grid { grid-template-columns: 1fr !important; }
          .tp-nav-inner { padding: 0 16px !important; }
          .tp-hero-inner { padding: 32px 18px 28px !important; }
          .tp-footer-inner { flex-direction: column !important; align-items: flex-start !important; gap: 16px !important; }
        }
      `}</style>

      <div style={{ background: "#0c0a09", minHeight: "100vh", fontFamily: "'Instrument Sans', sans-serif", color: "#e7e5e0" }}>

        {/* Nav */}
        <nav style={{ position: "sticky", top: 0, zIndex: 100, background: "rgba(12,10,9,0.92)", backdropFilter: "blur(12px)", borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
          <div className="tp-nav-inner" style={{ maxWidth: 760, margin: "0 auto", padding: "0 24px", height: 56, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <a href="/" style={{ display: "flex", alignItems: "center", gap: 8, textDecoration: "none" }}>
              <div style={{ width: 28, height: 28, background: "#d97706", borderRadius: 7, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, color: "#0c0a09", fontWeight: 800 }}>✦</div>
              <span className="tp-nav-wordmark" style={{ fontFamily: "'Syne', sans-serif", fontSize: 18, fontWeight: 800, color: "#fafaf9" }}>Limji</span>
            </a>
            <a href="/" style={{ fontSize: 13, fontWeight: 600, color: "#78716c", textDecoration: "none" }}>
              ← Back to home
            </a>
          </div>
        </nav>

        {/* Hero band */}
        <div style={{ borderBottom: "1px solid rgba(255,255,255,0.06)", background: "linear-gradient(135deg, #111110 0%, #0c0a09 100%)" }}>
          <div className="tp-hero-inner" style={{ maxWidth: 760, margin: "0 auto", padding: "48px 24px 36px" }}>
            <div className="tp-hero" style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <div style={{ display: "inline-flex", alignItems: "center", gap: 7, background: "rgba(217,119,6,0.1)", border: "1px solid rgba(217,119,6,0.25)", borderRadius: 20, padding: "4px 12px", width: "fit-content" }}>
                <span style={{ fontSize: 11, fontWeight: 700, color: "#d97706", letterSpacing: "0.08em", textTransform: "uppercase" }}>Legal</span>
              </div>
              <h1 className="tp-hero-title" style={{ fontFamily: "'Syne', sans-serif", fontSize: 36, fontWeight: 800, color: "#fafaf9", letterSpacing: "-0.02em", lineHeight: 1.1 }}>
                Terms of Service
              </h1>
              <div className="tp-hero-meta" style={{ display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
                <span style={{ fontSize: 13, color: "#57534e" }}>Effective: 1 March 2026</span>
                <span style={{ fontSize: 13, color: "#292524" }}>·</span>
                <span style={{ fontSize: 13, color: "#57534e" }}>Last updated: 1 March 2026</span>
              </div>
              <p style={{ fontSize: 15, color: "#78716c", lineHeight: 1.7, maxWidth: 580, marginTop: 4 }}>
                These terms govern your use of Limji. By using our service, you agree to them. We've written them in plain language — no legal tricks.
              </p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="tp-content" style={{ maxWidth: 760, margin: "0 auto", padding: "40px 24px 80px", display: "flex", flexDirection: "column", gap: 36 }}>

          {/* The service */}
          <div className="tp-section">
            <h2 className="tp-section-title" style={{ fontFamily: "'Syne', sans-serif", fontSize: 16, fontWeight: 800, color: "#fafaf9", marginBottom: 12, letterSpacing: "-0.01em" }}>
              1. The Service
            </h2>
            <p className="tp-body" style={{ fontSize: 15, color: "#a8a29e", lineHeight: 1.8 }}>
              Limji provides AI-powered tools for small businesses at <strong style={{ color: "#e7e5e0" }}>limji.app</strong>, including Smart Ads (ad copy generation), Smart Email (email drafting), and Smart Orders (order tracking and customer messaging). The service is provided as-is and may be updated, changed, or extended over time.
            </p>
          </div>

          {/* Accounts */}
          <div className="tp-section">
            <h2 className="tp-section-title" style={{ fontFamily: "'Syne', sans-serif", fontSize: 16, fontWeight: 800, color: "#fafaf9", marginBottom: 12, letterSpacing: "-0.01em" }}>
              2. Accounts & Eligibility
            </h2>
            <p className="tp-body" style={{ fontSize: 15, color: "#a8a29e", lineHeight: 1.8, marginBottom: 12 }}>
              You may use Limji without an account for up to 10 free generations. To continue, you must create an account. By creating an account, you confirm that:
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: 8, paddingLeft: 4 }}>
              {[
                "You are at least 18 years old",
                "The information you provide is accurate",
                "You will keep your password secure and not share your account",
                "You are responsible for all activity under your account",
              ].map((item, i) => (
                <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 10, fontSize: 14, color: "#a8a29e", lineHeight: 1.6 }}>
                  <span style={{ color: "#d97706", fontWeight: 800, flexShrink: 0, marginTop: 1 }}>✦</span>
                  {item}
                </div>
              ))}
            </div>
          </div>

          {/* Usage limits */}
          <div className="tp-section">
            <h2 className="tp-section-title" style={{ fontFamily: "'Syne', sans-serif", fontSize: 16, fontWeight: 800, color: "#fafaf9", marginBottom: 12, letterSpacing: "-0.01em" }}>
              3. Usage Limits & Fair Use
            </h2>
            <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 16 }}>
              {[
                { tier: "Anonymous", limit: "10 generations lifetime (IP-based)" },
                { tier: "Free account", limit: "3 generations per day · 10 active orders" },
                { tier: "Pro", limit: "150 generations per day · unlimited orders" },
              ].map(item => (
                <div key={item.tier} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 16px", background: "#111110", border: "1px solid #1c1917", borderRadius: 12, flexWrap: "wrap", gap: 8 }}>
                  <span style={{ fontSize: 14, fontWeight: 700, color: "#e7e5e0" }}>{item.tier}</span>
                  <span style={{ fontSize: 13, color: "#57534e" }}>{item.limit}</span>
                </div>
              ))}
            </div>
            <p style={{ fontSize: 14, color: "#78716c", lineHeight: 1.7 }}>
              Circumventing usage limits (e.g. creating multiple accounts, using proxies or VPNs to reset anonymous limits) is a violation of these terms and may result in account suspension.
            </p>
          </div>

          {/* Payments */}
          <div className="tp-section">
            <h2 className="tp-section-title" style={{ fontFamily: "'Syne', sans-serif", fontSize: 16, fontWeight: 800, color: "#fafaf9", marginBottom: 12, letterSpacing: "-0.01em" }}>
              4. Payments & Refunds
            </h2>
            <p className="tp-body" style={{ fontSize: 15, color: "#a8a29e", lineHeight: 1.8, marginBottom: 12 }}>
              Pro subscriptions are billed monthly ($19/month) or annually ($149/year) via Stripe. All prices are in USD.
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: 8, paddingLeft: 4, marginBottom: 14 }}>
              {[
                "You can cancel your subscription anytime from the Account page",
                "Cancellation takes effect at the end of the current billing period",
                "We offer a 7-day refund for new Pro subscriptions if you're not satisfied — email us",
                "Annual plans are refunded on a pro-rata basis within the first 30 days",
              ].map((item, i) => (
                <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 10, fontSize: 14, color: "#a8a29e", lineHeight: 1.6 }}>
                  <span style={{ color: "#d97706", fontWeight: 800, flexShrink: 0, marginTop: 1 }}>✦</span>
                  {item}
                </div>
              ))}
            </div>
            <div className="tp-highlight" style={{ padding: "14px 18px", background: "rgba(217,119,6,0.06)", border: "1px solid rgba(217,119,6,0.2)", borderRadius: 12 }}>
              <p style={{ fontSize: 13, color: "#a8a29e", lineHeight: 1.7, margin: 0 }}>
                To request a refund, email <strong style={{ color: "#d97706" }}>support@limji.app</strong> within the eligible window with your account email.
              </p>
            </div>
          </div>

          {/* Acceptable use */}
          <div className="tp-section">
            <h2 className="tp-section-title" style={{ fontFamily: "'Syne', sans-serif", fontSize: 16, fontWeight: 800, color: "#fafaf9", marginBottom: 12, letterSpacing: "-0.01em" }}>
              5. Acceptable Use
            </h2>
            <p className="tp-body" style={{ fontSize: 15, color: "#a8a29e", lineHeight: 1.8, marginBottom: 12 }}>
              You agree not to use Limji to:
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: 8, paddingLeft: 4 }}>
              {[
                "Generate spam, misleading, or fraudulent content",
                "Harass, threaten, or harm any individual or group",
                "Violate any applicable law or regulation",
                "Attempt to reverse-engineer, scrape, or abuse the API",
                "Impersonate other people or businesses",
                "Generate content that infringes on third-party intellectual property",
              ].map((item, i) => (
                <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 10, fontSize: 14, color: "#a8a29e", lineHeight: 1.6 }}>
                  <span style={{ color: "#ef4444", fontWeight: 800, flexShrink: 0, marginTop: 1 }}>✗</span>
                  {item}
                </div>
              ))}
            </div>
            <p style={{ fontSize: 14, color: "#57534e", lineHeight: 1.7, marginTop: 14 }}>
              Violations may result in immediate account suspension without refund.
            </p>
          </div>

          {/* Your content */}
          <div className="tp-section">
            <h2 className="tp-section-title" style={{ fontFamily: "'Syne', sans-serif", fontSize: 16, fontWeight: 800, color: "#fafaf9", marginBottom: 12, letterSpacing: "-0.01em" }}>
              6. Your Content & AI Output
            </h2>
            <p className="tp-body" style={{ fontSize: 15, color: "#a8a29e", lineHeight: 1.8, marginBottom: 12 }}>
              You own the content you input into Limji and the AI-generated output you receive. We do not claim ownership of your content.
            </p>
            <div className="tp-highlight" style={{ padding: "14px 18px", background: "rgba(217,119,6,0.06)", border: "1px solid rgba(217,119,6,0.2)", borderRadius: 12 }}>
              <p style={{ fontSize: 13, color: "#a8a29e", lineHeight: 1.7, margin: 0 }}>
                <strong style={{ color: "#d97706" }}>Important:</strong> AI-generated content may not always be accurate, unique, or legally clear. You are responsible for reviewing, editing, and verifying any content before using it commercially. Limji does not guarantee that generated content is free from copyright or trademark issues.
              </p>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="tp-section">
            <h2 className="tp-section-title" style={{ fontFamily: "'Syne', sans-serif", fontSize: 16, fontWeight: 800, color: "#fafaf9", marginBottom: 12, letterSpacing: "-0.01em" }}>
              7. Disclaimer & Limitation of Liability
            </h2>
            <p className="tp-body" style={{ fontSize: 15, color: "#a8a29e", lineHeight: 1.8, marginBottom: 12 }}>
              Limji is provided "as is" without warranties of any kind. We do not guarantee uninterrupted service, error-free output, or specific business results.
            </p>
            <p style={{ fontSize: 14, color: "#78716c", lineHeight: 1.7 }}>
              To the maximum extent permitted by law, Limji's total liability for any claim is limited to the amount you paid us in the 3 months preceding the claim, or $10, whichever is greater. We are not liable for indirect, incidental, or consequential damages.
            </p>
          </div>

          {/* Termination */}
          <div className="tp-section">
            <h2 className="tp-section-title" style={{ fontFamily: "'Syne', sans-serif", fontSize: 16, fontWeight: 800, color: "#fafaf9", marginBottom: 12, letterSpacing: "-0.01em" }}>
              8. Termination
            </h2>
            <p className="tp-body" style={{ fontSize: 15, color: "#a8a29e", lineHeight: 1.8 }}>
              You can close your account at any time from the Account page. We may suspend or terminate accounts that violate these terms. If we terminate your account without cause, we will refund any unused paid period.
            </p>
          </div>

          {/* Governing law */}
          <div className="tp-section">
            <h2 className="tp-section-title" style={{ fontFamily: "'Syne', sans-serif", fontSize: 16, fontWeight: 800, color: "#fafaf9", marginBottom: 12, letterSpacing: "-0.01em" }}>
              9. Governing Law
            </h2>
            <p className="tp-body" style={{ fontSize: 15, color: "#a8a29e", lineHeight: 1.8 }}>
              These terms are governed by the laws of the United Arab Emirates. Any disputes will be resolved through good-faith negotiation first. If unresolved, disputes will be subject to the jurisdiction of UAE courts.
            </p>
          </div>

          {/* Contact */}
          <div className="tp-section">
            <h2 className="tp-section-title" style={{ fontFamily: "'Syne', sans-serif", fontSize: 16, fontWeight: 800, color: "#fafaf9", marginBottom: 12, letterSpacing: "-0.01em" }}>
              10. Contact
            </h2>
            <div style={{ padding: "20px", background: "#111110", border: "1px solid #1c1917", borderRadius: 14 }}>
              <p style={{ fontSize: 14, color: "#78716c", lineHeight: 1.7, marginBottom: 14 }}>
                Questions about these terms? Reach out and we'll respond personally.
              </p>
              <div className="tp-contact-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                <a href="mailto:support@limji.app" style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 14px", background: "#1c1917", border: "1px solid #292524", borderRadius: 10, textDecoration: "none" }}>
                  <span style={{ fontSize: 16 }}>✉️</span>
                  <div>
                    <div style={{ fontSize: 11, fontWeight: 700, color: "#57534e", letterSpacing: "0.06em", textTransform: "uppercase" }}>Email</div>
                    <div style={{ fontSize: 13, color: "#d97706", fontWeight: 600 }}>support@limji.app</div>
                  </div>
                </a>
                <a href="/privacy" style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 14px", background: "#1c1917", border: "1px solid #292524", borderRadius: 10, textDecoration: "none" }}>
                  <span style={{ fontSize: 16 }}>🔒</span>
                  <div>
                    <div style={{ fontSize: 11, fontWeight: 700, color: "#57534e", letterSpacing: "0.06em", textTransform: "uppercase" }}>Also read</div>
                    <div style={{ fontSize: 13, color: "#d97706", fontWeight: 600 }}>Privacy Policy</div>
                  </div>
                </a>
              </div>
            </div>
          </div>

          {/* Changes */}
          <div className="tp-section" style={{ paddingBottom: 8 }}>
            <h2 className="tp-section-title" style={{ fontFamily: "'Syne', sans-serif", fontSize: 16, fontWeight: 800, color: "#fafaf9", marginBottom: 12, letterSpacing: "-0.01em" }}>
              11. Changes to These Terms
            </h2>
            <p className="tp-body" style={{ fontSize: 15, color: "#a8a29e", lineHeight: 1.8 }}>
              We may update these terms occasionally. If changes are material, we'll notify you by email at least 7 days before they take effect. Continued use of Limji after the effective date means you accept the updated terms.
            </p>
          </div>

        </div>

        {/* Footer */}
        <footer style={{ borderTop: "1px solid rgba(255,255,255,0.05)", padding: "24px 24px 32px" }}>
          <div className="tp-footer-inner" style={{ maxWidth: 760, margin: "0 auto", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <div style={{ width: 22, height: 22, background: "#d97706", borderRadius: 5, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, color: "#0c0a09" }}>✦</div>
              <span style={{ fontFamily: "'Syne', sans-serif", fontSize: 14, fontWeight: 800, color: "#44403c" }}>Limji</span>
            </div>
            <div style={{ display: "flex", gap: 20, flexWrap: "wrap" }}>
              <a href="/privacy" style={{ fontSize: 12, color: "#44403c", textDecoration: "none" }}>Privacy Policy</a>
              <a href="/terms" style={{ fontSize: 12, color: "#d97706", textDecoration: "none", fontWeight: 600 }}>Terms of Service</a>
              <a href="/" style={{ fontSize: 12, color: "#44403c", textDecoration: "none" }}>Home</a>
            </div>
            <span style={{ fontSize: 12, color: "#292524" }}>© 2026 Limji</span>
          </div>
        </footer>

      </div>
    </>
  );
}
